import { Flex, Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { Tabs } from "antd";
import { useEffect, useState } from "react";
import InputComponent from "../../components/Input";
import { CreditCardIcon } from "../../styles/icons/CreditCardIcon";
import { AddBrandModal } from "./modal/addBrandModal";
import { DeletBrandModal } from "./modal/deletBrandModal";
import "./utils/styles.css"
const { TabPane } = Tabs;

export function CredicardSection({ organizateRateOld, organizateRateNew, setOrganizateRateNew, resetTrigger, onEdit }) {
    const [tabStatus, setTabStatus] = useState<string>("ONLINE");
    const [organizedRates, setOrganizedRates] = useState(null);


    function capitalizeFirstOnly(text) {
        if (!text) return "";
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }


    function handleInputChangeDay(origin, newDay) {
        if (!newDay || isNaN(newDay)) return;
    
        setOrganizedRates((prevRates) => {
            const updatedRates = { ...prevRates };
    
            updatedRates[origin] = updatedRates[origin].map((brand) => ({
                ...brand,
                repaymentDayModel: {
                    ...brand.repaymentDayModel,
                    day: newDay,
                },
            }));
    
            setOrganizateRateNew((prevNew) => ({
                ...prevNew,
                [origin]: updatedRates[origin], 
            }));
    
            return updatedRates;
        });
    }
    




    function organizeNames(name) {
        if (name === "ONLINE") {
            return "Online"
        }
        if (name === "TAP_TO_PAY") {
            return "Tap"
        }
        if (name === "POS") {
            return "POS"
        }
        if (name === "GLOBAL") {
            return "GLOBAL"
        }
    }



    function handleInputChange(origin, brandName, installmentIndex, newValue) {
        setOrganizedRates((prevRates) => {
            const updatedRates = { ...prevRates };
    
            updatedRates[origin] = updatedRates[origin].map((brand) => {
                if (brand.paymentBrandModel?.brandCard === brandName) {
                    return {
                        ...brand,
                        rates: brand.rates.map((rate, index) =>
                            index === installmentIndex
                                ? { ...rate, paymentFeeValue: newValue }
                                : rate
                        ),
                    };
                }
                return brand;
            });
    
            setOrganizateRateNew(updatedRates);
            return updatedRates;
        });
    }
    useEffect(() => {
        if (resetTrigger && organizateRateOld) {
            setOrganizedRates(JSON.parse(JSON.stringify(organizateRateOld)));
        }
        //eslint-disable-next-line 
    }, [resetTrigger, organizateRateOld]);

    useEffect(() => {
        if (organizateRateNew) {
            setOrganizedRates(JSON.parse(JSON.stringify(organizateRateNew)))
        }
        //eslint-disable-next-line 

    }, [organizateRateNew]);


    if (!organizedRates?.ONLINE?.[0]?.repaymentDayModel) {
        return <Text>Carregando...</Text>;
    }

    return (
        <Flex flexDir="column" gap="26px">
            <Flex gap=".4rem" margin="1rem 0 0" alignItems="center">
                <CreditCardIcon size={21} />
                <Text fontFamily="Hero New" fontWeight="600" fontSize="16px"  >Cartão de crédito</Text>
            </Flex>

            {organizedRates?.ONLINE?.[0]?.repaymentDayModel?.day !== undefined && (
                <Flex flexDirection="column" gap="16px" >
                    <Text fontSize="16px" fontWeight="400" lineHeight="26px" color="#141A28">
                        Tempo de repasse
                    </Text>
                    <Flex
                        gap="23.5px"
                        w="496px"
                        justifyContent="space-between"
                    >
                        <InputComponent
                            leftLabel="Link"
                            isTransferTime={true}
                            onChange={(newValue) => handleInputChangeDay("ONLINE", newValue)}
                            value={organizedRates?.ONLINE?.[0]?.repaymentDayModel?.day || 0}
                            onEdit={onEdit}
                        />

                        <InputComponent
                            leftLabel="POS"
                            isTransferTime={true}
                            onChange={(newValue) => handleInputChangeDay("POS", newValue)}
                            value={organizedRates?.POS?.[0]?.repaymentDayModel?.day || 0}
                            onEdit={onEdit}
                        />

                        <InputComponent
                            leftLabel="Tap"
                            isTransferTime={true}
                            onChange={(newValue) => handleInputChangeDay("TAP_TO_PAY", newValue)}
                            value={organizedRates?.TAP_TO_PAY?.[0]?.repaymentDayModel?.day || 0}
                            onEdit={onEdit}
                        />

                    </Flex>
                </Flex>
            )}
            <Flex
                w="496px"
                alignItems="center"
                justifyContent="space-between"
            >
                <Text>Taxas</Text>
                <AddBrandModal
                    setOrganizedRates={setOrganizateRateNew}
                    tabStatus={tabStatus}
                    organizedRates={organizateRateNew}
                    onEdit={onEdit}
                />
            </Flex>

            <Flex>
                <Tabs
                    defaultActiveKey="ONLINE"
                    onChange={(key) => setTabStatus(key)}
                    tabBarStyle={{
                        borderBottom: "0px solid #fff",
                        padding: "0 8px",
                    }}
                    className="custom-tabs"
                >
                    {


                        Object.keys(organizedRates)
                            .map((origin) => {

                                if (origin !== "GLOBAL") {
                                    return (
                                        <TabPane
                                            tab={<span style={{ maxWidth: "200px", border: "hidden", width: "80px", display: "inline-block", textAlign: "center" }}>{organizeNames(origin)}</span>}
                                            key={origin}
                                        >
                                            <Flex justifyContent="center" mt="-16px">
                                                <Table
                                                    variant="striped"
                                                    colorScheme="none"
                                                    border="1px solid rgba(232, 232, 232, 1)"
                                                    borderRadius="4px"
                                                    overflow="hidden"
                                                    sx={{
                                                        borderCollapse: "separate",
                                                        borderSpacing: "0",
                                                    }}
                                                >
                                                    <Thead
                                                    >
                                                        <Tr
                                                            border="1px solid rgba(232, 232, 232, 1)"
                                                        >
                                                            <Th
                                                                borderRight="0.1px solid rgba(232, 232, 232, 0.5)"
                                                                borderBottom="1px solid rgba(232, 232, 232, 1)"
                                                                minW="48px"
                                                            ></Th>
                                                            {organizedRates[origin]
                                                                .map((brand, idx) => (
                                                                    <Th key={idx}
                                                                        borderBottom="1px solid rgba(232, 232, 232, 1)"
                                                                        p="0"
                                                                        textTransform="none"
                                                                    >
                                                                        <Flex justifyContent="center" h="31px" alignItems="center">
                                                                            <Text
                                                                                fontSize="12px"
                                                                                fontFamily="Hero New"
                                                                                lineHeight="22px"
                                                                                fontWeight="normal"
                                                                                color="#3D485C"
                                                                            >
                                                                                {brand?.paymentBrandModel ? capitalizeFirstOnly(brand?.paymentBrandModel?.brandCard) : "Padrão"}

                                                                            </Text>
                                                                            {
                                                                                brand?.paymentBrandModel !== null &&
                                                                                <DeletBrandModal
                                                                                    onEdit={onEdit}
                                                                                    setOrganizedRates={setOrganizateRateNew}
                                                                                    tabStatus={tabStatus}
                                                                                    brand={brand} />
                                                                            }
                                                                        </Flex>
                                                                    </Th>
                                                                ))}
                                                        </Tr>
                                                    </Thead>
                                                    <Tbody
                                                    >
                                                        {Array.from({ length: 24 }, (_, index) => (
                                                            <Tr key={index}
                                                                border="1px solid rgba(232, 232, 232, 1)"
                                                                borderRadius="10px"
                                                            >
                                                                <Td
                                                                    borderRight="0.1px solid rgba(232, 232, 232, 0.5)"
                                                                    borderBottom={index === 23 ? "1px solid #fff" : "1px solid rgba(232, 232, 232, 1)"}
                                                                    fontWeight="500"
                                                                    color="#262F40"
                                                                    fontFamily="Hero New"
                                                                    p="0 10px"
                                                                    w="48px"
                                                                >{index + 1}x</Td>

                                                                {organizedRates[origin].map((OR, idx) => (

                                                                    <Td
                                                                        key={`${OR?.paymentBrandModel?.brandCard || `default-${idx}`}-${index}`}
                                                                        borderBottom={index === OR?.rates?.length - 1 ? "1px solid #fff" : "1px solid rgba(232, 232, 232, 1)"}
                                                                        p="0"
                                                                        justifyContent="center"

                                                                    >
                                                                        <Flex
                                                                            justifyContent="center"
                                                                            margin="0 20px"
                                                                            alignContent="center"
                                                                            alignItems="center"
                                                                            h="42px"
                                                                        >
                                                                            <InputComponent
                                                                                width="70px"
                                                                                isPercentage={true}
                                                                                fontSize="14px"
                                                                                value={OR.rates[index]?.paymentFeeValue ?? ""}
                                                                                onChange={(e) => handleInputChange(origin, OR?.paymentBrandModel?.brandCard, index, e)}
                                                                                onEdit={onEdit}
                                                                            />

                                                                        </Flex>
                                                                    </Td>
                                                                ))}
                                                            </Tr>
                                                        ))}
                                                    </Tbody>
                                                </Table>
                                            </Flex>
                                        </TabPane>

                                    )
                                }
                                return null
                                // eslint-disable-next-line
                            })}
                </Tabs>
            </Flex>
        </Flex >
    );
}
